import { useQuery } from '@apollo/client';
import { physicianPushAvailability } from '../graph/physicianPush';

export default function usePhysicianPushEnabled(eligible = true): boolean {
  const { data, error, loading } = useQuery<{ physicianPushEnabled: boolean }>(physicianPushAvailability, {
    skip: !eligible,
    fetchPolicy: 'cache-and-network',
  });
  // Unknown capability, missing field or failed query must not bypass SMS restrictions.
  return eligible && !loading && !error && data?.physicianPushEnabled === true;
}
